import { Navigate, useLocation } from "@/lib/router-compat";

const CATEGORY_TO_TYPE: Record<string, string> = {
  cars: "car",
  vans: "van",
  boats: "boat",
  trucks: "truck",
  "light-trucks": "truck",
  motorcycle: "motorcycle",
  motorcycles: "motorcycle",
  utilaje: "construction",
  machinery: "construction",
};

const remapParams = (params: URLSearchParams, targetType?: string) => {
  const out = new URLSearchParams();

  if (targetType) {
    out.set("type", targetType);
  }

  params.forEach((value, key) => {
    if (!value) return;
    if (key === "category") return;
    if (key === "mileage_unit") return;

    const mappedKey =
      key === "price_min" ? "priceMin" :
      key === "price_max" ? "priceMax" :
      key === "year_min" ? "yearMin" :
      key === "year_max" ? "yearMax" :
      key === "mileage_max" ? "mileageTo" :
      key === "km_max" ? "mileageTo" :
      key;

    // Don't override mapped type
    if (mappedKey === "type" && targetType) return;

    out.set(mappedKey, value);
  });

  return out;
};

/** Target URL for a legacy /anunturi query string (used for the server 301). */
export function anunturiTarget(search: string): string {
  const params = new URLSearchParams(search);
  const type = CATEGORY_TO_TYPE[params.get("category") || ""] || undefined;
  const qs = remapParams(params, type).toString();
  return qs ? `/vehicles?${qs}` : "/vehicles";
}

export default function AnunturiRedirect() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const category = params.get("category") || "";
  const type = CATEGORY_TO_TYPE[category] || undefined;

  const outParams = remapParams(params, type);
  const qs = outParams.toString();

  return <Navigate to={qs ? `/vehicles?${qs}` : "/vehicles"} replace />;
}
